"use strict";

var ItemVariant = /* @__PURE__ */(ItemVariant2 => {
  ItemVariant2["Default"] = "default";
  ItemVariant2["Dropdown"] = "dropdown";
  ItemVariant2["ColumnList"] = "column-list";
  return ItemVariant2;
})(ItemVariant || {});
var ModalId = /* @__PURE__ */(ModalId2 => {
  ModalId2["Account"] = "account";
  ModalId2["Language"] = "language";
  ModalId2["MobileMenu"] = "mobileMenu";
  return ModalId2;
})(ModalId || {});
export { ModalId };
//# sourceMappingURL=types.mjs.map
